// Import React components
import { useEffect, useRef, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import {
  Nav,
  Navbar,
  NavDropdown,
  Dropdown,
  DropdownButton,
  Button,
} from "react-bootstrap";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faAddressCard,
  faListCheck,
  faCog,
  faAddressBook,
  faMessage,
  faTicket,
  faCogs,
  faList,
  faUser,
  faUserEdit,
  faRightFromBracket,
  faSliders,
  faDashboard,
  faCloud,
  faDesktop,
  faScrewdriverWrench,
  faPersonRunning,
  faArrowRotateForward,
  faSignal,
  faTextHeight,
  faTextWidth,
  faMagnifyingGlassChart,
  faWaveSquare,
  faPerson,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";

// Import the custom components
import { loginRequest, protectedResources, b2cPolicies } from "../authConfig";
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import companyLogo from "../images/logos/DOMMICRO.svg";
import baseGLogo from "../images/logos/10BaseG.ico";

export const NavigationBar = () => {
  const [searchParams] = useSearchParams();
  const { instance, inProgress } = useMsal();
  let activeAccount;

  if (instance) {
    activeAccount = instance.getActiveAccount();
  }

  // MSAL Related Objects
  const { error, execute } = useFetchWithMsal({
    scopes: [
      ...protectedResources.scopes.read,
      ...protectedResources.scopes.write,
    ],
  });

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect();
  };

  const handleProfileEdit = () => {
    if (inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.editProfile);
    }
  };

  useEffect(() => {
  }, [execute]);

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="light"
        className="navbar-custom"
      >
        <div className="container-fluid navbarContainer">
          <Navbar.Brand href="/">
            <img
              src={companyLogo}
              alt="DOMMICRO Logo"
              style={{
                height: "44px",
                margin: "0px 0px 0px 0px",
                padding: "0px 0px 0px 0px",
              }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav.Link className="navbarButton" href="Services">
              Services
            </Nav.Link>
            <Nav.Link className="navbarButton" href="Projects">
              Projects
            </Nav.Link>
            <Nav.Link className="navbarButton" href="About">
              About
            </Nav.Link>
            <Nav.Link className="navbarButton" href="Support">
              Support
            </Nav.Link>
            <Nav.Link className="navbarButton" href="Contact">
              Contact Us
            </Nav.Link>
            <AuthenticatedTemplate>
              <div className="navbar-collapse justify-content-end">
                <Nav>
                  <NavDropdown
                    title={
                      <span>
                        {activeAccount !== null ? activeAccount.name : ""}
                      </span>
                    }
                    id="collasible-nav-dropdown"
                    className="navbarButton navAlignRight"
                  >
                    <NavDropdown.Item
                      href="https://techguydom.com?loginRedirect=true"
                      className="navBarItemRight"
                    >
                      TechGuyDom.com
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="https://10baseg.com?loginRedirect=true"
                      className="navBarItemRight"
                    >
                      10BaseG.com
                    </NavDropdown.Item>
                    <NavDropdown.Divider className="navBarHr" />
                    <NavDropdown.Item
                      href="/System/ClaimsList"
                      className="navBarItemRight"
                    >
                      Claims List
                    </NavDropdown.Item>
                    <NavDropdown.Divider className="navBarHr" />
                    <NavDropdown.Item
                      href="#"
                      onClick={handleLogoutRedirect}
                      className="navBarItemRight"
                    >
                      Sign out
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <div className="navbar-collapse justify-content-end">
                <Nav.Link
                  className="navbarButton navbarSignIn"
                  href="#"
                  onClick={() => handleLoginRedirect()}
                >
                  Sign in
                </Nav.Link>
              </div>
            </UnauthenticatedTemplate>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};
